// =============================
// Imports
// =============================

import { required } from '../index';

// =============================
// Validator
// =============================

const validator = {
  publisher_name: required,
};

export default validator;
